import { render, staticRenderFns } from "./FileFolders.vue?vue&type=template&id=ede7e2b2&scoped=true"
import script from "./FileFolders.vue?vue&type=script&lang=js"
export * from "./FileFolders.vue?vue&type=script&lang=js"
import style0 from "./FileFolders.vue?vue&type=style&index=0&id=ede7e2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede7e2b2",
  null
  
)

export default component.exports